var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10 -6 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.4C17.5 3 16.8 3 9.8 3 2.8 3 2.5 3 1 4.4c-1.2 1.2-1 5.8-1 5.8s-.2 4.4 1 5.5C2.5 17 2.8 17 9.8 17c7 0 7.7 0 9.2-1.4 1.2-1.1 1-5.5 1-5.5s.2-4.6-1-5.7zM8 13V7l6 3-6 3z",
    fill: "#fff"
  })));
}
export default SvgYoutube;